import React from 'react';
import { ElementType, LinkText, SpecType, SubType } from '../../../utils/RioUtils/interfaces';
import { sendRioEvent } from '../../../utils/RioUtils/rioHelper';
import { parseTncPromptText, isContentAvailable, getTncPromptText } from '../helper';
import { BillingHeading, FlexContainer, InlineTncWrapper, StickyContainer, TermsAndConditionsContainer } from '../styled';
import { SecondaryButton } from '@chegg-ui/button';
import { useTnCBehavior } from '../hooksHelper';
import { ContentDisplayMode } from '../interfaces';
import { DataTestAttributes } from '../constants';
export var TncInline = function TncInline(_ref) {
  var _ref$isCouponApplied = _ref.isCouponApplied,
    isCouponApplied = _ref$isCouponApplied === void 0 ? false : _ref$isCouponApplied,
    onRioEventFired = _ref.onRioEventFired,
    content = _ref.content,
    onError = _ref.onError,
    namespace = _ref.namespace,
    headingLevel = _ref.headingLevel,
    price = _ref.price,
    priceWithDiscount = _ref.priceWithDiscount,
    _ref$isOpen = _ref.isOpen,
    isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
    isOpenCallback = _ref.isOpenCallback,
    formattedTermsContent = _ref.formattedTermsContent,
    _ref$ctaLabel = _ref.ctaLabel,
    ctaLabel = _ref$ctaLabel === void 0 ? 'Join now' : _ref$ctaLabel,
    billingCycleContentKey = _ref.billingCycleContentKey;
  if (!content) return null;
  var verifyContent = isContentAvailable(content, ContentDisplayMode.INLINE, onError);
  if (!verifyContent) return null;
  var _useTnCBehavior = useTnCBehavior({
      content: content,
      isOpen: isOpen,
      onError: onError,
      contentDisplayMode: ContentDisplayMode.INLINE,
      isOpenCallback: isOpenCallback,
      onRioEventFired: onRioEventFired,
      namespace: namespace
    }),
    setTncOpen = _useTnCBehavior.setTncOpen,
    inlineTncRef = _useTnCBehavior.inlineTncRef,
    termsTextTitle = _useTnCBehavior.termsTextTitle,
    backButtonText = _useTnCBehavior.backButtonText,
    cheggTermsOfUseLink = _useTnCBehavior.cheggTermsOfUseLink,
    privacyPolicyLink = _useTnCBehavior.privacyPolicyLink,
    cheggTermsOfUseText = _useTnCBehavior.cheggTermsOfUseText,
    privacyPolicyText = _useTnCBehavior.privacyPolicyText,
    tncPromptText = _useTnCBehavior.tncPromptText,
    tncPromptTextWithCoupon = _useTnCBehavior.tncPromptTextWithCoupon,
    tncPromptTextWithDuration = _useTnCBehavior.tncPromptTextWithDuration,
    termsTitle = _useTnCBehavior.termsTitle,
    tncLinkRef = _useTnCBehavior.tncLinkRef,
    tncOpen = _useTnCBehavior.tncOpen,
    billingHeading = _useTnCBehavior.billingHeading,
    planDuration = _useTnCBehavior.planDuration,
    frequency = _useTnCBehavior.frequency;
  var linkClickAction = function linkClickAction(event, elementText, openModal) {
    openModal && event.preventDefault();
    sendRioEvent({
      info: LinkText.TERMS_AND_PRIVACY_POLICY,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.LINK,
      callback: onRioEventFired,
      namespace: namespace,
      elementText: elementText
    });
    openModal && setTncOpen(true);
  };
  var onCtaClick = function onCtaClick(event) {
    event.preventDefault();
    sendRioEvent({
      info: LinkText.CLICK_BACK,
      specType: SpecType.INTERACTION,
      subType: SubType.CLICK,
      elementType: ElementType.BUTTON,
      callback: onRioEventFired,
      namespace: namespace
    });
    setTncOpen(false);
  };
  var tncLinkInfo = {
    tncPromptText: getTncPromptText({
      isCouponApplied: isCouponApplied,
      billingCycleContentKey: billingCycleContentKey,
      tncPromptTextWithCoupon: tncPromptTextWithCoupon,
      tncPromptText: tncPromptText,
      tncPromptTextWithDuration: tncPromptTextWithDuration
    }),
    termsTitle: termsTitle,
    linkClickAction: linkClickAction,
    tncLinkRef: tncLinkRef,
    upiTou: content.upiTou || '',
    upiVendorPrivacyPolicyUrl: content.upiVendorPrivacyPolicyUrl,
    upiVendorPrivacyPolicyText: content.upiVendorPrivacyPolicyText
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TermsAndConditionsContainer, {
    "data-test": DataTestAttributes.TERMS_AND_CONDITIONS_INLINE
  }, billingHeading && !tncOpen && /*#__PURE__*/React.createElement(BillingHeading, {
    "data-test": DataTestAttributes.BILLING_HEADING,
    "aria-level": headingLevel
  }, billingHeading), !tncOpen && parseTncPromptText({
    tncLinkInfo: tncLinkInfo,
    cheggTermsOfUseLink: cheggTermsOfUseLink,
    privacyPolicyLink: privacyPolicyLink,
    price: price,
    priceWithDiscount: priceWithDiscount,
    cheggTermsOfUseText: cheggTermsOfUseText,
    privacyPolicyText: privacyPolicyText,
    ctaLabel: ctaLabel,
    planDuration: planDuration === null || planDuration === void 0 ? void 0 : planDuration[billingCycleContentKey],
    frequency: frequency === null || frequency === void 0 ? void 0 : frequency[billingCycleContentKey]
  }), tncOpen && /*#__PURE__*/React.createElement(InlineTncWrapper, {
    "data-test": 'TNC_INLINE_CONTENT',
    tabIndex: -1,
    ref: inlineTncRef
  }, /*#__PURE__*/React.createElement("h2", {
    "data-test": 'TNC_INLINE_CONTENT-title'
  }, termsTextTitle), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: formattedTermsContent
  }), /*#__PURE__*/React.createElement(StickyContainer, null, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(SecondaryButton, {
    "data-test": 'TNC_INLINE_BACK_BUTTON',
    onClick: onCtaClick,
    size: 'medium',
    onKeyDown: function onKeyDown(e) {
      /* istanbul ignore next - jest thinks this isn't covered but it is (test: `should do nothing when tabbing on the back to checkout button`) */
      if (e.key === 'Tab') {
        /*
         * This is the only focusable element in inline t&c so tabbing should not do anything.
         */
        e.preventDefault();
      }
    },
    disableHoverAnimation: true
  }, backButtonText))))));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/components/TermsAndConditions/variants/TncInline.js
// module id = 4019
// module chunks = 11